

import {Directive, ElementRef, HostListener, Input, OnInit,} from '@angular/core';
import { of } from 'rxjs';

@Directive({
  selector: 'button[b-responsive]',
})
export class ButtonResponsiveDirective implements OnInit {

  @Input('b-responsive') buttonResponsive: boolean;

  constructor(
    private element: ElementRef<HTMLInputElement>
  ) {
    console.log(element);
  }
  @HostListener('window:resize')
  resize() {
    this.toggle();
  }
  ngOnInit(): void {
    this.toggle();
    
  }
  toggle() {
    if (this.element) {
      let children = this.element.nativeElement.children;
      let parent = this.element.nativeElement.parentElement;
      let textSpan = children.item(1);
      if (textSpan && parent.clientWidth < this.element.nativeElement.clientWidth) {
        textSpan.classList.add('display-none');
      } else {
        textSpan.classList.remove('display-none');
      }
    }
  }
}

